import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { importSpreadsheetInterface } from 'src/app/util/interfaces/importSpreadsheetInterface';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CmdbLoadService {
	postCmdbLoadUrl = environment.baseApiUrl + 'load/cmdb';
	getExcelTemplateUrl = environment.baseApiUrl + 'load/cmdb';
	getExcelItemTemplateUrl = environment.baseApiUrl + 'load/cmdb/item?{qryString}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	postCmdbLoad(uploadBody: importSpreadsheetInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.post(this.postCmdbLoadUrl, uploadBody, { headers: headers });
	}

	getExcelTemplate(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get(this.getExcelTemplateUrl, { headers: headers });
	}

	getExcelItemTemplate(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get(this.getExcelItemTemplateUrl.replace('{qryString}', ''), { headers: headers });
	}
}
